import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlatiOnlineComponent } from './plati-online.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { GetAccessoriesComponent } from './getAccessories/get-accessories.component';
import { ResponseComponent } from './response/response.component';
import { RequestComponent } from './request/request.component';

@NgModule({
  declarations: [PlatiOnlineComponent, GetAccessoriesComponent, ResponseComponent, RequestComponent],
  imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule
  ],
})
export class PlatiOnlineModule {}
